export const SWH_URL_CATALOG = '/produtos'
export const SWH_URL_CATALOG_CREATE = '/produtos/cadastro'
export const SWH_URL_CATALOG_EDIT = '/produtos/${id}'
export const SWH_URL_ONLINE_CATALOG = '/catalogo-online'
export const SWH_URL_ONLINE_CATALOG_SHIPPING = '/catalogo-online/frete'
export const SWH_URL_SALES = '/swh/vendas'
export const SWH_URL_INVOICES = '/notas-fiscais'
export const SWH_URL_INVOICE_SETTINGS = '/configuracoes/nota-fiscal'

export const SWH_ROUTES_ONLINE_CATALOG = ['/swh/online-catalog', SWH_URL_ONLINE_CATALOG] as const

export const SWH_ROUTES_ONLINE_CATALOG_SHIPPING = [
  '/swh/online-catalog/shipping',
  SWH_URL_ONLINE_CATALOG_SHIPPING
] as const

export const SWH_ROUTES_CATALOG_SOURCE = [SWH_URL_CATALOG, SWH_URL_CATALOG_CREATE, SWH_URL_CATALOG_EDIT] as const

export const SWH_ROUTES_CATALOG = [
  '/swh/products',
  '/swh/products/new',
  '/swh/products/edit/[id]',
  ...SWH_ROUTES_CATALOG_SOURCE
] as const

export const SWH_ROUTES_INVOICE_SETTINGS = ['/swh/settings/invoice', SWH_URL_INVOICE_SETTINGS] as const

export const SWH_ROUTES = [
  ...SWH_ROUTES_CATALOG,
  SWH_URL_INVOICE_SETTINGS,
  SWH_URL_INVOICES,
  SWH_URL_CATALOG_CREATE,
  SWH_URL_SALES,
  ...SWH_ROUTES_ONLINE_CATALOG,
  ...SWH_ROUTES_ONLINE_CATALOG_SHIPPING,
  '/swh/vendas/${id}'
] as const
